<template>
  <el-dialog
    title="新增商品"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="goodsname"
        label="商品名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.goodsname"></el-input>
      </el-form-item>
      <el-form-item
        prop="bar_code"
        label="条形码"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.bar_code"></el-input>
      </el-form-item>
      <el-form-item
              prop="googs_no"
              label="商品编号"
      >
        <el-input v-model="form.googs_no"></el-input>
      </el-form-item>
        <el-form-item label="封面图片" prop="goodsimg"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form.goodsimg" style="display:none"></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove"
                  :on-success="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
        建议尺寸1000*600像素，大小1M以内，支持jpg、png、jpeg格式
      </el-form-item>
      <el-form-item
        prop="googstype_id"
        label="商品分类"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.googstype_id"
                placeholder="请选择商品分类"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.serial_number"
                  :label="item.category_name"
                  :value="item.serial_number"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="ruletype_id"
              label="规格分类"
      >
        <el-select
                multiple
                collapse-tags
                class="filter-item"
                v-model="form.ruletype_id"
                placeholder="请选择规格分类"
        >
          <el-option
                  v-for="item in ruletypeOptions"
                  :key="item.id"
                  :label="item.ruletype_name"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>




      <el-form-item
              prop="goodsprice"
              label="优惠价格"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.goodsprice" style="width:100px"></el-input>元
      </el-form-item>
      <el-form-item
              prop="originalprice"
              label="原价格"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.originalprice" style="width:100px"></el-input>元
      </el-form-item>
      <el-form-item
              prop="total_num"
              label="库存"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.total_num"></el-input>
      </el-form-item>
      <el-form-item
              prop="valuation_unit"
              label="计价单位"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.valuation_unit"></el-input>
      </el-form-item>
      <el-form-item label="商品详情图" prop="goodsimg2">
        <el-input v-model="form.goodsimg2" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=10
                :auto-upload="true"
                :file-list="fileList2"
                :before-upload="handleBeforeUpload2"
                :on-remove="handleRemove2"
                :on-success="handlePictureCardPreview2">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小1M以内，支持jpg、png、jpeg格式
      </el-form-item>

        <el-form-item
                prop="goodsnote"
                label="商品介绍"
        >

          <el-input type="textarea" placeholder="..."  style="width: 90%;" :rows="6" maxlength="500" @input = "descInput" v-model="form.goodsnote">

          </el-input>
          <span class="circle"></span><span class="text">{{remnant}}/500</span>

        </el-form-item>
      <el-form-item
      >
        <el-checkbox v-model="checked">上架</el-checkbox>



      </el-form-item>
      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        formEdit: true,
        checked:true,
      loading: false,
      dialogVisible: false,
        dialogImageUrl: '',
        fileList: [],
        fileList2: [],
        fileList3: [],
        imageNum: 0 ,
        remnant:0,//输入数
        pickerOptions:{},
        typeOptions: [],
        ruletypeOptions: [],
        ruletype_id: [],
      form: {
          goodsimg:'',
          dateRange: []
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
      descInput(){
          var txtVal = this.form.goodsnote.length;
          this.remnant = txtVal;
      },
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('agentid', util.cookies.get('agentid'));
        agentService.getGoodtyps(formData2).then(data => {
            this.typeOptions=data;
        });
        agentService.getRuletyps(formData2).then(data => {
            this.ruletypeOptions=data;
        });
        this.fileList2=[];
        this.fileList3=[];
        if (this.oneagent.id) {
            // userService.getUser(this.user.id).then(data => {
            let form = {};
            form.goodsname = this.oneagent.goodsname;
            form.bar_code = this.oneagent.bar_code;
            form.googs_no = this.oneagent.googs_no;
            form.googstype_id =this.oneagent.googstype_id;
            if(this.oneagent.ruletype_id!=null && this.oneagent.ruletype_id!=""){
                let countlistArray=[];
               let strs = this.oneagent.ruletype_id.split(","); //字符分割

                for ( let i=0; i<strs.length; i++ ){
                    countlistArray.push(parseInt(strs[i]));
                }
                form.ruletype_id=countlistArray;

            }else{
                form.ruletype_id  =[];
            }

            form.goodsprice = this.oneagent.goodsprice;
            form.originalprice = this.oneagent.originalprice;
            form.total_num = this.oneagent.total_num;
            form.valuation_unit = this.oneagent.valuation_unit;
            form.goodsnote = this.oneagent.goodsnote;
            if(this.oneagent.goodsimg!=null && this.oneagent.goodsimg!="") {
                form.goodsimg = this.oneagent.goodsimg;
                this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + this.oneagent.goodsimg}]
            }
            if(this.oneagent.detailsimg!=null && this.oneagent.detailsimg!="") {
                let tmpCenter = this.oneagent.detailsimg.split(',');
                for (let index = 0; index < tmpCenter.length; index++) {
                    this.fileList3.push(tmpCenter[index]);
                    this.fileList2.push({url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/'+ tmpCenter[index],url22: tmpCenter[index]});
                }
            }

            if(this.oneagent.types=='0'){
                this.checked=true;
            }else{
                this.checked=false;
            }
            this.form = form;
            // });
            this.formEdit = true;

        } else {
            this.fileList=[];
            this.fileList2=[];
            this.fileList3=[];
            this.formEdit = true;
            this.form = {};
        }
    },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },

      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
          this.form.goodsimg ="";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
          console.log("url==="+file.url);
          this.form.goodsimg = file.url;
          this.dialogVisible = true;
      },

      // 上传文件之前的钩子
      handleBeforeUpload2(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },

      // 文件列表移除文件时的钩子
      handleRemove2(file, fileList) {
          console.log("url222==="+JSON.stringify(fileList));
          this.fileList3=[];
          for (let index = 0; index < fileList.length; index++) {
              if(fileList[index].response!=null){
              console.log("url5555==="+fileList[index].response.url);
              this.fileList3.push(fileList[index].response.url);
              }else{
                  console.log("url5555==="+fileList[index].url22);
                  this.fileList3.push(fileList[index].url22);
              }
          }
          this.form.goodsimg2 ="1";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview2(file) {
          console.log("url==="+file.url);
          this.fileList3.push(file.url);
          this.form.goodsimg2 = "1";
          this.dialogVisible = true;
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            console.log("url4444==="+this.fileList3.length);
            console.log("url5555==="+this.fileList3);
                let types=1;
                if(this.checked){
                    types=0;
                }
            this.loading = true;
            agentService.saveGoods({ ...this.form,agentid:util.cookies.get('agentid'),types:types,id:this.oneagent.id,detailsimg:this.fileList3})
                .then(data => {
                    this.loading = false;
                    this.dialogVisible = false;
                    this.$emit("submit");
                });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

